/**
 * Created by Denis Kuzin on 03 march 2022
 */

const ClanMessages = function () {
    this.onMessagesUpdated = function () {};

    this.messages = [];

    cleverapps.userClan.onLoaded = this.loadMessages.bind(this);
};

ClanMessages.prototype.loadMessages = function (callback) {
    callback = callback || function () {};

    if (cleverapps.userClan.id === undefined) {
        this.messages = [];

        callback();
        return;
    }

    this.loadMessagesRequest((data) => {
        //        console.log("loadMessagesRequest", data);

        this.messages = data.messages.sort((a, b) => a.messageId - b.messageId).map((message) => new ClanMessage(message));

        cleverapps.toolbar.resetByType(ToolbarItem.CLANS);
        this.onMessagesUpdated();
        callback();
    }, () => {
        cleverapps.notification.create(Messages.get("ClanErrors.connectionError"));
        callback();
    });
};

ClanMessages.prototype.updateMessages = function (messages) {
    (messages || []).forEach((messageData) => {
        const index = this.messages.findIndex((message) => message.messageId === messageData.messageId);

        if (index !== -1) {
            this.messages[index].update(messageData);
        } else {
            this.messages.push(new ClanMessage(messageData));
        }
    });

    this.messages.sort((a, b) => a.messageId - b.messageId);
};

ClanMessages.prototype.loadMessagesRequest = function (onSuccess, onFailure) {
    const data = {
        userId: connector.platform.getUserID(),
        version: cleverapps.config.version
    };
    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/${connector.config.projectId}/message/list/${cleverapps.userClan.id}`, data, onSuccess, onFailure);
};

ClanMessages.prototype.postMessage = function (messageData) {
    if (messageData.playerId === undefined) {
        messageData.playerId = connector.platform.getUserID();
    }
    if (messageData.clanId === undefined) {
        messageData.clanId = cleverapps.userClan.id;
    }

    const message = new ClanMessage(messageData);

    this.messages.push(message);
    this.onMessagesUpdated();
    cleverapps.effects.fire("clan.message.send");

    const revertMessage = function () {
        const index = this.messages.indexOf(message);
        if (index !== -1) {
            this.messages.splice(index, 1);
            this.onMessagesUpdated();
        }
    }.bind(this);

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/message/create`, {
        userId: message.playerId,
        clanId: cleverapps.userClan.id,
        type: message.type
    }, (data) => {
        if (data.error) {
            cleverapps.notification.create(Messages.get(data.error));
            revertMessage();
        } else {
            message.posted(data.messageId);
        }
    }, () => {
        cleverapps.notification.create(Messages.get("ClanErrors.connectionError"));
        revertMessage();
    });
};

ClanMessages.prototype.sendHelp = function (messageId, senderId) {
    cleverapps.effects.fire("clan.help.send");
    cleverapps.loading.show();

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/message/sendhelp`, {
        messageId,
        userId: senderId,
        version: cleverapps.config.version
    }, (data) => {
        // console.log("sendHelp response", data);
        cleverapps.loading.hide();

        if (data.error) {
            cleverapps.notification.create(Messages.get(data.error));
        }

        this.updateMessages(data.messages);
        this.onMessagesUpdated();
    }, () => {
        cleverapps.loading.hide();
        cleverapps.notification.create(Messages.get("ClanErrors.connectionError"));
    });
};

ClanMessages.prototype.collectHelp = function (help, source) {
    const message = help.message;

    cleverapps.loading.show();

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/message/collecthelp`, {
        userId: connector.platform.getUserID(),
        helpId: help.helpId
    }, (data) => {
        cleverapps.loading.hide();

        if (data.error) {
            cleverapps.notification.create(Messages.get(data.error));
        } else {
            help.collect(source);
            message.onHelpUpdated();
        }
    }, () => {
        cleverapps.loading.hide();
        cleverapps.notification.create(Messages.get("ClanErrors.connectionError"));
    });
};

ClanMessages.prototype.collectGift = function (gift, source) {
    const message = gift.message;

    cleverapps.loading.show();

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/message/collectgift`, {
        userId: connector.platform.getUserID(),
        giftId: gift.giftId
    }, (data) => {
        cleverapps.loading.hide();

        if (data.error) {
            cleverapps.notification.create(Messages.get(data.error));
        } else {
            gift.collect(source);
            message.onGiftUpdated();
        }
    }, () => {
        cleverapps.loading.hide();
        cleverapps.notification.create(Messages.get("ClanErrors.connectionError"));
    });
};

ClanMessages.prototype.getUserMessageTimeout = function (messageType) {
    let timeout = ClansConfig.MESSAGE_FLOOD_TIMEOUT;
    let messages = this.messages.filter((message) => message.playerId === connector.platform.getUserID());

    if (ClansConfig.MESSAGES[messageType] && ClansConfig.MESSAGES[messageType].help) {
        timeout = ClansConfig.MESSAGE_HELP_TIMEOUT;
        messages = messages.filter((message) => message.type === messageType);
    }

    const message = messages[messages.length - 1];
    return message && Math.max(0, message.date + timeout - Date.now()) || 0;
};

ClanMessages.prototype.listMessages = function () {
    return this.messages.filter((message) => {
        const timeLeft = message.getTimeLeft();
        return message.clanId === cleverapps.userClan.id && (timeLeft === undefined || timeLeft > 0);
    });
};

ClanMessages.prototype.listActiveRequests = function () {
    const messages = cleverapps.clanMessages.listMessages();
    return messages.filter((mes) => mes.isHelpMessage() && mes.getTimeLeft() > 0);
};

ClanMessages.prototype.listActiveGifts = function () {
    const messages = cleverapps.clanMessages.listMessages();
    return messages.filter((mes) => mes.isGiftMessage() && mes.getTimeLeft() > 0);
};

ClanMessages.prototype.canSendHelp = function () {
    return this.listActiveRequests().filter((req) => req.canHelp() && !req.isUserMessage()).length > 0;
};

ClanMessages.prototype.canGrabHelp = function () {
    return this.listActiveRequests().filter((req) => {
        if (req.isUserMessage()) {
            return req.listHelp().some((help) => !help.isReceived());
        }
        return false;
    }).length > 0;
};

ClanMessages.prototype.canClaimGift = function () {
    return this.listActiveGifts().filter((req) => {
        if (!req.isUserMessage()) {
            return req.gift && !req.gift.isReceived();
        }
        return false;
    }).length > 0;
};

ClanMessages.prototype.needsAttention = function () {
    return this.canGrabHelp() || this.canSendHelp() || this.canClaimGift();
};
